import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import pages from "../data/pages.json";

const ORIGIN = "https://abs-mcs.com";

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const route = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const p = pages.find((pg) => pg.path === route);

    const meta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.append(el);
      }
      el.content = content;
    };

    if (route.startsWith("/admin")) {
      document.title = "Team Inbox — ABS LLC";
      meta("name", "robots", "noindex");
      return;
    }
    if (route.startsWith("/payment")) {
      document.title = "Payment | ABS LLC";
      meta("name", "robots", "noindex");
      return;
    }
    if (!p) {
      document.title = "Page not found | ABS LLC";
      meta("name", "robots", "noindex");
      return;
    }

    const robotsEl = document.head.querySelector('meta[name="robots"]');
    if (robotsEl) robotsEl.remove();

    document.title = p.title;
    meta("name", "description", p.description);
    for (const [key, val] of Object.entries({
      "og:title": p.title,
      "og:description": p.description,
      "og:url": ORIGIN + p.path,
    })) {
      meta("property", key, val);
    }
    meta("name", "twitter:title", p.title);
    meta("name", "twitter:description", p.description);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.append(link);
    }
    link.href = ORIGIN + p.path;

    for (const el of document.querySelectorAll('script[type="application/ld+json"]')) {
      try {
        const data = JSON.parse(el.textContent);
        if (data["@graph"]) {
          for (const node of data["@graph"]) {
            if (node.isPartOf?.["@id"] === ORIGIN + "/#website") {
              Object.assign(node, {
                "@type": p.type,
                "@id": ORIGIN + p.path + "#webpage",
                url: ORIGIN + p.path,
                name: p.title,
                description: p.description,
              });
            }
          }
          el.textContent = JSON.stringify(data);
        }
      } catch {
        /* preserve unrelated markup */
      }
    }
  }, [pathname]);

  return null;
}
